export const inactivityThresholds = [
  { label: '5 minutes', value: 300000 },
  { label: '10 minutes', value: 600000 },
  { label: '15 minutes', value: 900000 },
  { label: '30 minutes', value: 1800000 },
  { label: '1 hour', value: 3600000 },
  { label: '2 hours', value: 7200000 },
  { label: '5 hours', value: 18000000 },
  { label: '10 hours', value: 36000000 },
  { label: '12 hours', value: 43200000 },
  { label: '1 day', value: 86400000 },
  { label: '7 days', value: 604800000 }
];